import Configuration from "./configuration";

class CampaignService {
  constructor(token) {
    this.config = new Configuration(token, null, "api/Campaign");
  }

  async getAllVariablesCampaign() {
    return this.config.API.get(`GetAllVariablesCampaign`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  getOptionVariableCampaign(variableName) {
    return this.config.API.get(`GetOptionVariableCampaign`, {
      params: {
        variableName
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method getConfigurationCampaign list configuration campaign
   * @param  {String} campaignId id exist campaign
   * @return {Promise} result configuration
   */
  getConfigurationCampaign(campaignId) {
    return this.config.API.get(`GetConfigurationCampaign`, {
      params: { campaignId }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method saveConfigurationCampaign save configuration campaign or get campaign configuration
   * @return {Promise} result configuration
   */
  saveConfigurationCampaign(campaignId = undefined, objectCampaign = {}) {
    const body = Object.assign(
      {
        campaignId
      },
      objectCampaign
    );

    return this.config.API.post(`SaveConfigurationCampaign`, body).then(
      response => {
        if (response.status !== 200) {
          return this.config.handleResponseError(response);
        }
        return response.data;
      }
    );
  }

  /**
   * @method getCustomersCampaign list all customer for campaign
   * @param {UUID} CampaignId identity campaign
   * @param {Number} Skip number of page
   * @param {Number} Take total expect result
   * @param {Number} TypeCustomerCampaign filter customer values 0 = customers bad info, 1 = customers in central risk, 2 = all customers
   * @return {Promise} result object customers
   */
  getCustomersCampaign(
    CampaignId = undefined,
    Skip = 0,
    Take = 10,
    TypeCustomerCampaign = 2
  ) {
    return this.config.API.post("GetCustomersCampaign", {
      CampaignId,
      Skip,
      Take,
      TypeCustomerCampaign
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  async getCampaigns() {
    return this.config.API.get(`GetCampaigns`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  async discardCampaign(CampaignId) {
    return this.config.API.get(`DiscardCampaign`, {
      params: { CampaignId }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  async queueFilterCampaign(campaignId) {
    return this.config.API.post(`QueueFilterCampaign`, { campaignId }).then(
      response => {
        if (response.status !== 200) {
          return this.config.handleResponseError(response);
        }
        return response.data;
      }
    );
  }

  async queueLaunchCampaign(
    applyQueryCentralRisk,
    applyUpdateData,
    campaignId,
    projectedCustomer,
    projectedAmount,
    targetAmount,
    targetCustomer
  ) {
    return this.config.API.post(`QueueLaunchCampaign`, {
      applyQueryCentralRisk,
      applyUpdateData,
      campaignId,
      projectedAmount,
      projectedCustomer,
      targetAmount,
      targetCustomer
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  async listDashboardCampaign() {
    return this.config.API.get(`https://api.myjson.com/bins/fdmtu`).then(
      response => {
        if (response.status !== 200) {
          return this.config.handleResponseError(response);
        }
        return response.data;
      }
    );
  }

  async detailCampaingDashboard() {
    return this.config.API.get(`https://api.myjson.com/bins/xu2ky`).then(
      response => {
        if (response.status !== 200) {
          return this.config.handleResponseError(response);
        }
        return response.data;
      }
    );
  }
}

export default CampaignService;
